<template>
  <div>
      <i class="el-icon-download" @click="download(value)" title="下载" style="margin-left: 20px;font-size: 15px"></i>
  </div>
</template>
<script>
  export default {
    data: function () {
      return {
        value: null,
        number: null,
      }
    },
    mounted() {

    },
    methods: {
      download(value) {
        let self = this
        this.$emit('clickModule')
      }
    }
  }
</script>
<style scoped>
  .stepSuc :hover {
    cursor: pointer;
  }
</style>
